import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Snackbar } from "@aviary";
import { SSRHeadContent, LazyHotReloadIndicator, LazyReactAxe } from "@shared/components";
import { useServer } from "@shared/hooks";
import { Footer } from "@unauthenticated/catalog/components";
import { SEOHelper } from "@unauthenticated/catalog/components/SEOHelper";
import { l } from "@unauthenticated/catalog/locales/i18n";
import { Pages } from "@unauthenticated/catalog/scenes";

import { PageHeader } from "./PageHeader";
import { useOpenCatalogPageViewLogger } from "./useOpenCatalogPageViewLogger";

import * as styles from "./MainContent.styles";

const MainContent: FC = () => {
  const { ssr } = useServer();
  useOpenCatalogPageViewLogger();
  const { t } = useTranslation();

  const renderDevTools = () => {
    if (ssr) return null;

    return (
      <>
        <LazyHotReloadIndicator />
        <LazyReactAxe />
      </>
    );
  };

  const renderPages = () => {
    return (
      <div css={styles.spacer}>
        <Pages />
      </div>
    );
  };

  return (
    <>
      <SSRHeadContent />
      <SEOHelper title={t(l.common.title)} description={t(l.common.metaDescription)} />
      <div data-testid="open-main-content" css={styles.footerHelper}>
        <PageHeader />
        <Snackbar />
        {renderDevTools()}
        {renderPages()}
      </div>
      <Footer />
    </>
  );
};

export { MainContent };
